/**
 * Available order type
 */
export const ORDER_TYPES = {
  inStore:  'in_store',
  curbside: 'curbside',
  dineIn:   'dine_in',
};

/**
 * Categories id for different product.
 */
export const CATEGORY_ID = {
  BURGER_PROTEIN:                 65,
  BURGER_STYLE:                   66,
  BURGER_CHEESE:                  67,
  BURGER_SAUCE:                   68,
  BURGER_TOPPINGS:                69,
  BURGER_PREMIUM_TOPPINGS:        70,
  BURGER_BUNDLE:                  71,
  KIDS_BURGER_BUNDLE:             131,
  KIDS_FRIES_BUNDLE:              132,
  BUNDLE_FRIES:                   72,
  KIDS_BUNDLE_FRIES:              133,
  BUNDLE_SAUCES:                  73,
  BUNDLE_DRINK:                   74,
  KIDS_BUNDLE_DRINK:              119,
  GRILLED_CHEESE_BUNDLE_DRINK:    121,
  FRIES_DIPPERS:                  77,
  KIDS_FRIES_DIPPERS:             134,
  FRIES:                          78,
  KIDS_BURGER:                    79,
  FRIES_CHEESE:                   106,
  FRIES_SAUCE:                    107,
  FRIES_TOPPINGS:                 108,
  FRIES_PREMIUM_TOPPINGS:         109,
  KIDS_BURGER_STYLE:              80,
  KIDS_GRILLED_CHEESE:            88,
  KIDS_GRILLED_CHEESE_WRAP:       89,
  KIDS_TREASURE_BOX:              135,
  TREASURE_BOX_BUNDLE_DRINK:      136,
  TREASURE_BOX_KIDS_FRIES_BUNDLE: 137,
  APPETIZERS:                     138,
  APPETIZER_DIPPERS:              139,
  GRILLED_CHICKEN_STRIPS:         94,
  GRILLED_CHICKEN_STRIPS_DIPPERS: 95,
  KIDS_FRIES:                     116,
  KIDS_BURGER_SAUCE:              82,
  KIDS_BURGER_TOPPINGS:           83,
  KIDS_BURGER_PREMIUM_TOPPINGS:   84,
  KIDS_BURGER_FRIES:              85,
  KIDS_CHICKEN_STRIPS_FRIES:      96,
  KIDS_DIPPERS:                   115,
  KIDS_DRINKS:                    114,
  BOWL_PROTEIN:                   99,
  BOWL:                           100,
  BOWL_CHEESE:                    101,
  BOWL_SAUCE:                     102,
  BOWL_TOPPINGS:                  103,
  BOWL_PREMIUM_TOPPINGS:          104,
  BOWL_BUNDLE:                    110,
  BOSS_FRIES:                     105,
};

/**
 * Modifiers id for different product.
 */
export const MODIFIER_ID = {
  ADD_EXTRA: 620,
};

/**
 * Category id of `no_bundle` item
 */
export const NO_BUNDLE_ITEM_ID = 791;

/**
 * Path of green icon for drinks
 */
export const DRINK_BIG_IMAGE = 'ProductImages/drinks_big.png';

export const PRODUCTS_ID = {
  KIDS_BURGER:            '23',
  BOSS_BURGER:            '15',
  BOSS_BOWL:              '17',
  GRILLED_CHEESE:         '24',
  TREASURE_BOX:           '30',
  GRILLED_CHICKEN_STRIPS: '25',
  SIMPLE_FRIES:           '16',
  BOSS_FRIES:             '26',
  DRINKS:                 '19',
};

/**
 * Kiosk breakpoint.
 */
export const KIOSK_BREAKPOINT = 1080;

export const SOME_API_ERROR_MSG = 'Something went wrong. Please try again later or contact info@burgerboss.com';

export const LOCAL_FCM_TOKEN = 'LOCAL_FCM_TOKEN';

export const DEBOUNCE_ORDER_QUANTITY_CALC = 800;

export default {
  ORDER_TYPES,
  CATEGORY_ID,
  NO_BUNDLE_ITEM_ID,
  PRODUCTS_ID,
  KIOSK_BREAKPOINT,
  SOME_API_ERROR_MSG,
};



// WEBPACK FOOTER //
// ./src/config/constants.js